import { IOnePageStyles } from 'layouts/OnePagePreviewLayout/types';
import { useUpdateBusinessPlan } from 'services/businessPlan/hooks';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getBusinessPlan, getSetBusinessPlan } from 'store/useBusinessToolStore/selectors';

import { useAuthenticated } from 'hooks/useAuthenticated';
import usePromiseStatus from 'hooks/usePromiseStatus';

import { getValidatedMetadata } from 'helpers/metadataParser';
import ToastService from 'helpers/ToastService';

export const useUpdateOnePageStyle = () => {
  const { isAuthenticated, isAuthConfiguring } = useAuthenticated();
  const businessPlan = useBusinessToolStore(getBusinessPlan);
  const setBusinessPlan = useBusinessToolStore(getSetBusinessPlan);
  const updateMutation = useUpdateBusinessPlan();
  const { track, isPending } = usePromiseStatus();

  const styleChangeHandler = async (style: IOnePageStyles, closeFn?: VoidFunction) => {
    const metadata = { ...getValidatedMetadata(businessPlan.metadata), onePageTemplateStyle: style };

    if (!(isAuthenticated || isAuthConfiguring)) {
      setBusinessPlan({ ...businessPlan, metadata });
      closeFn?.();

      return;
    }

    try {
      const params = {
        id: businessPlan.uuid,
        body: { metadata: JSON.stringify(metadata) },
      };

      await track(updateMutation.mutateAsync(params));
      closeFn?.();
    } catch (error) {
      error instanceof Error && ToastService.showError(error.message);
    }
  };

  return {
    styleChangeHandler,
    isPending,
  }
};
